<c-container class="mt-5" data-testid="manage-region-tax-rates-container">
  <h2 class="mb-4">Manage Region Tax Rates</h2>
  <c-row class="mb-3">
    <c-col>
      @if (!countriesLoaded()) {
        <mat-spinner class="align-center" data-testid="countries-loading-spinner"></mat-spinner>
      } @else {
        <mat-form-field appearance="outline" class="full-width mb-3">
          <mat-label>Country</mat-label>
          <mat-select data-testid="country-select" [formControl]="selectionForm.controls.country" (selectionChange)="onCountryChange()">
            @for (country of countries; track country.Id) {
              <mat-option [value]="country.Id" data-testid="country-option">{{ country.Name }}</mat-option>
            }
          </mat-select>
          <mat-hint>Select a country to view its regions</mat-hint>
        </mat-form-field>

        @if (regions.length > 0) {
          <mat-form-field appearance="outline" class="full-width mb-3">
            <mat-label>Province/Region</mat-label>
            <mat-select data-testid="region-select" [formControl]="selectionForm.controls.region" (selectionChange)="onRegionChange()">
              @for (region of regions; track region.Id) {
                <mat-option [value]="region.Id" data-testid="region-option">{{ region.Name }}</mat-option>
              }
            </mat-select>
            <mat-hint>Select a province/region to view and edit tax rates</mat-hint>
          </mat-form-field>
        }

        @if (selectedRegionId()) {
          @if (!taxRatesLoaded()) {
            <mat-spinner class="align-center" data-testid="tax-rates-loading-spinner"></mat-spinner>
          } @else {
            <mat-tab-group dynamicHeight disableRipple data-testid="tax-rates-tab-group">

              <mat-tab label="Tax Rates" data-testid="tax-rates-tab">
                <div class="pt-3">
                  @if (hasScheduledRate) {
                    <div class="alert alert-warning d-flex align-items-center gap-2 mb-3" data-testid="scheduled-rate-notice">
                      <mat-icon class="flex-shrink-0">schedule</mat-icon>
                      <span>A rate change is already scheduled. Cancel it from the History tab before creating a new one.</span>
                    </div>
                  }

                  <mat-card>
                    <mat-card-header>
                      <mat-card-title>Current Rates</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                      @if (currentTaxRate(); as rate) {
                        <div class="rates-row">
                          <div>
                            <div class="detail-label">GST Rate</div>
                            <div class="detail-value" data-testid="gst-rate-display">{{ formatRate(rate.GstRate) }}</div>
                          </div>
                          <div>
                            <div class="detail-label">{{ pstLabel }} Rate</div>
                            <div class="detail-value" data-testid="pst-rate-display">{{ formatRate(rate.PstRate) }}</div>
                          </div>
                          <div>
                            <div class="detail-label">HST Rate</div>
                            <div class="detail-value" data-testid="hst-rate-display">{{ formatRate(rate.HstRate) }}</div>
                          </div>
                        </div>
                        <div class="margin-top-med">
                          <button
                            mat-raised-button
                            color="primary"
                            data-testid="edit-tax-rates-button"
                            (click)="openEditDialog()"
                            [disabled]="hasScheduledRate">
                            <mat-icon>edit</mat-icon>
                            Edit Tax Rates
                          </button>
                        </div>
                      }
                    </mat-card-content>
                  </mat-card>
                </div>
              </mat-tab>

              <mat-tab label="History" data-testid="history-tab">
                <app-region-tax-rate-history [regionId]="selectedRegionId()"></app-region-tax-rate-history>
              </mat-tab>

            </mat-tab-group>
          }
        }
      }
    </c-col>
  </c-row>
</c-container>
